export default "__VITE_ASSET__77b96891__"